import styled from 'styled-components'
import { Box, Text } from '@usap/uicomponents'

export const TotalWmoText = styled(Text)`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  color: #282832 
`
